import 'babel-polyfill';
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import axios from 'axios';


//导入权限
import './mixins/permission'
import permission from "./directive/permission/permission";


// import Qs from 'qs';
import router from './router';
import filters from './filters';
import Cookies from 'js-cookie';
import Bus from './vueBus.js';
import Mixin from './mixins';
// import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-default/index.css'
// import 'vue-orgchart/dist/style.min.css'


//导入编辑器样式
import VueQuillEditor from 'vue-quill-editor'
import * as Quill from 'quill'
//导入编辑器样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'



// 设置字体大小
const fontSizeStyle = Quill.import('attributors/style/size') // 引入这个后会把样式写在style上
fontSizeStyle.whitelist = [ '14px', '16px', '18px', '20px', '24px', '28px', '32px']
Quill.register(fontSizeStyle, true)
const Font = Quill.import('attributors/style/font') // 引入这个后会把样式写在style上
const fonts = [
  'SimSun',
  'SimHei',
  'Microsoft-YaHei',
  'KaiTi',
  'FangSong'
]
Font.whitelist = fonts // 将字体加入到白名单
Quill.register(Font, true)
var Align = Quill.import('attributors/style/align')
Quill.register(Align, true)

var Direction = Quill.import('attributors/style/direction')

Quill.register(Direction, true)
//编辑器
Vue.use(VueQuillEditor);


import {
  Loading,	Upload,
  Button,
  Input,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  DatePicker,
  TimeSelect,
  TimePicker,
  Table,
  TableColumn,
  Select,
  Option,
  Dialog,
  Pagination,
  Form,
  FormItem,
  MessageBox,
  Message,
  Checkbox,
  CheckboxGroup,
  Radio,
  Tree,
  Tabs,
  TabPane,
  Tooltip,
  Badge,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  RadioGroup,
  Tag,
  Cascader,
  Breadcrumb,
  BreadcrumbItem,
  Autocomplete,
  Carousel,
  CarouselItem,
  Steps,
  Step
} from 'element-ui';

const components = [
  Button,
	Upload,
  Input,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  DatePicker,
  TimeSelect,
  TimePicker,
  Table,
  TableColumn,
  Select,
  Option,
  Dialog,
  Pagination,
  Form,
  FormItem,
  MessageBox,
  Message,
  Checkbox,
  CheckboxGroup,
  Radio,
  Tree,
  Tabs,
  TabPane,
  Tooltip,
  Badge,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  RadioGroup,
  Tag,
  Cascader,
  Breadcrumb,
  BreadcrumbItem,
  Autocomplete,
  Carousel,
  CarouselItem,
  Steps,
  Step
];

// 实例化Vue的filters
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));
Vue.use(Loading.directive);

//导入权限
Vue.directive('permission', permission)

components.map(component => {
  Vue.component(component.name, component);
});
Vue.prototype.$xeMessageBox = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$xeMessage = Message;
Vue.prototype.$xeStore = window.localStorage;
window.$wxeMessage = Vue.prototype.$xeMessage = Message;
Vue.prototype.$xeCookies = Vue.$xeCookies = Cookies;
Vue.prototype.$xeBus = Bus;
// Vue.prototype.$http = axios.create({
//     timeout: 50000
// });
Vue.config.productionTip = false;
window.$axios = Vue.$http = Vue.prototype.$http = axios.create({
  timeout: 50000
});
//if (process.env.NODE_ENV === 'test') {
//Vue.prototype.$http.defaults.baseURL = 'http://qa-yunmis.xebest.com/';
Vue.prototype.$http.defaults.baseURL = '/api';
Vue.prototype.$http.defaults.headers.loginStatus = sessionStorage.getItem('loginStatus')
//};

Vue.config.productionTip = process.env.NODE_ENV === 'development';

// // POST传参序列化
Vue.prototype.$http.interceptors.request.use((config) => {
  // config.headers.nonestr = '123';
  // if (config.method === 'POST' || config.method === 'post') {
  //     config.data = Qs.stringify(config.data);
  // }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// code状态码200判断
Vue.prototype.$http.interceptors.response.use((res) => {
  if (res.data.status === '0000') {
    return res.data;
  } else {
    if (res.data.status === '0001' || res.data.status === '0002' || res.data.status === '0003') {
      // 0001 操作失败 0002 无权限 0003 缺少必要参数
      Message.error(res.data.msg);
      return Promise.reject(res);
    } else if (res.data.status === '0004') {
      // 0004 未登录
      Message.error(res.data.msg);
      router.replace({name: 'login', query: {redirect: router.currentRoute.fullPath}});
      return Promise.reject(res);
    } else {
      Message.error(res.data.msg);
      return Promise.reject(res);
    }
  }
}, () => {
  Message.error('接口请求失败或超时！请刷新重试~');
  /* eslint-disable prefer-promise-reject-errors */
  return Promise.reject({status: 'xe404'});
});

Vue.mixin(Mixin);

// 点击body隐藏高级搜索框
$(function() {
  $('body').on('click', function (event) {
    if ($('.advancedSearch').is(':visible')) {
      $('.advancedSearch').animate({right: '-10%', opacity: 0}, 100, () => {
        $('.advancedSearch').hide();
        Bus.$emit('on-advancedSearch-hide', false);
      });
    };
  });
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
});
Vue.config.productionTip = false;



// WEBPACK FOOTER //
// ./src/main.js